/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global.js" ;
	import * as helper from "../../js/helper.js";
	import full_loading from "../components/full-loading.vue";
    import VueSelect from '../../js/vue-select.js';
    import vueSlider from '../../js/vue-slider-component.umd.min.js';
    
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            vue_select:VueSelect,
            vueSlider: vueSlider
        },
		name:'map_search_widget',
        props: {
            hidden_fields: {
                default: function () {
                    return [];
                }
            },
            for_guest: {
                type: Boolean,
                default: false
            },
            search_filters_prop: {
                default: function () {
                    return global.search_projects_filters;
                }
            },
        },
		data() {
			return {
                ageRange: [2, 5],
                global,
                helper,
                frappe,
                search_filters:this.search_filters_prop,
                all_regions:[],
                cities:[],
                districts:[],
                value: [0,40],
                first_refresh:false,
                formatter2: v => `${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ﷼`,
                options: {
                    dotSize: 14,
                    width: 'auto',
                    height: 4,
                    contained: false,
                    direction: 'ltr',
                    data: null,
                    dataLabel: 'label',
                    dataValue: 'value',
                    interval: 1,
                    disabled: false,
                    clickable: true,
                    duration: 0.5,
                    adsorb: true,
                    lazy: true,
                    tooltip: 'active',
                    tooltipPlacement: 'top',
                    tooltipFormatter: void 0,
                    useKeyboard: false,
                    keydownHook: null,
                    dragOnClick: true,
                    enableCross: true,
                    fixed: false,
                    minRange: void 0,
                    maxRange: void 0,
                    order: true,
                    marks: false,
                    dotOptions: void 0,
                    dotAttrs: void 0,
                    process: true,
                    dotStyle: void 0,
                    railStyle: void 0,
                    processStyle: void 0,
                    tooltipStyle: void 0,
                    stepStyle: void 0,
                    stepActiveStyle: void 0,
                    labelStyle: void 0,
                    labelActiveStyle: void 0,
                }
			}
		},
        mounted(){
            global.emitter.on("refresh_filters", args => {
                this.first_refresh = true;
                this.$forceUpdate();
            });
            global.emitter.on("update-filters", args => {
                this.filters_updated();
            });
            global.emitter.on("load_regions_n_cities", args => {
                this.load_regions();
                this.load_cities();
            });
            this.load_regions();
            this.load_cities();
        },
		methods: {
			load_regions: async function () {
                this.all_regions = await global.global_params.get_regions(with_bounds = false);
                this.$forceUpdate();
			},
			load_cities: async function () {
                if(this.search_filters.region)
                    this.cities = await global.global_params.get_cities(this.search_filters.region.region_id);
                else
                this.cities = await global.global_params.get_cities();
                this.$forceUpdate();
			},
			load_districts: async function () {
                return;
                this.districts = await global.global_params.get_districts(this.search_filters.city.city_id);
                this.$forceUpdate();
			},
			check_enabled: function(field){
				if (!this.search_filters.property_type)
					return true;
				return this.enabled_fields.includes(field);
			},
            filters_updated: function (){
                global.emitter.emit("load-search-again");
                global.emitter.emit("update-search-tablets");
            },
            array_to_vue_select_obj: function(array){
                return array.map((value) => {
                    return {label: helper.t(value), code: value}
                })
            }
		},
		computed:{
            enabled_fields(){
                var fields = global.property_constants.property_types[this.search_filters.property_type];
                return fields;
            },
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "searchProjectsFiltersModal",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h5",
              {
                staticClass: "modal-title",
                attrs: { id: "staticBackdropLabel" }
              },
              [_vm._v(_vm._s(_vm.helper.t("Filters")))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "filter-popup" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "filter-form" }, [
                  _c("form", [
                    _c("div", { staticClass: "row" }, [
                      !_vm.hidden_fields.includes("region")
                        ? _c("div", { staticClass: "col-lg-6 col-sm-6" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.helper.t("Region")))
                                ]),
                                _vm._v(" "),
                                _c("vue_select", {
                                  attrs: {
                                    options: _vm.all_regions,
                                    label: _vm.helper.t("name_en"),
                                    reduce: function(region) {
                                      return region
                                    },
                                    dir: _vm.frappe.lang_dir
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.search_filters.city = null
                                      _vm.load_cities()
                                      _vm.filters_updated()
                                    }
                                  },
                                  model: {
                                    value: _vm.search_filters.region,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.search_filters,
                                        "region",
                                        $$v
                                      )
                                    },
                                    expression: "search_filters.region"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hidden_fields.includes("city")
                        ? _c("div", { staticClass: "col-lg-6 col-sm-6" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.helper.t("City")))
                                ]),
                                _vm._v(" "),
                                _c("vue_select", {
                                  attrs: {
                                    options: _vm.cities,
                                    label: _vm.helper.t("name_en"),
                                    reduce: function(city) {
                                      return city
                                    },
                                    dir: _vm.frappe.lang_dir
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.load_districts()
                                      _vm.filters_updated()
                                    }
                                  },
                                  model: {
                                    value: _vm.search_filters.city,
                                    callback: function($$v) {
                                      _vm.$set(_vm.search_filters, "city", $$v)
                                    },
                                    expression: "search_filters.city"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "add-listing" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.helper.t("Property Types")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "features-content mt-2" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.search_filters.property_types, function(
                            status,
                            property_type
                          ) {
                            return _vm.check_enabled(property_type)
                              ? _c(
                                  "div",
                                  { staticClass: "col-lg-3 col-md-4" },
                                  [
                                    _c("ul", [
                                      _c(
                                        "li",
                                        {
                                          attrs: { role: "button" },
                                          on: {
                                            click: function($event) {
                                              _vm.search_filters.property_types[
                                                property_type
                                              ] = !_vm.search_filters
                                                .property_types[property_type]
                                              _vm.filters_updated()
                                            }
                                          }
                                        },
                                        [
                                          status
                                            ? _c("i", {
                                                staticClass:
                                                  "ri-checkbox-circle-fill"
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "ri-checkbox-blank-circle-line"
                                              }),
                                          _vm._v(
                                            "\n                                                        " +
                                              _vm._s(
                                                _vm.helper.t(
                                                  property_type + "s"
                                                )
                                              ) +
                                              "\n                                                    "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0c56d12a_0", { source: "\n.modal-dialog{\n    min-width: 60% !important;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/modal/search-mashro-filters-modal.vue"],"names":[],"mappings":";AAmNA;IACA,yBAAA;AACA","file":"search-mashro-filters-modal.vue","sourcesContent":["<template>\r\n    <div class=\"modal fade filter-popup-area\" id=\"searchProjectsFiltersModal\" data-bs-keyboard=\"false\" tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\r\n        <div class=\"modal-dialog modal-dialog-centered\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <h5 class=\"modal-title\" id=\"staticBackdropLabel\">{{ helper.t(\"Filters\") }}</h5>\r\n                </div>\r\n                <div class=\"modal-body\">\r\n                    <!-- Start Filter Area -->\r\n                    <div class=\"filter-popup\">\r\n                        <div class=\"container\">\r\n                            <div class=\"filter-form\">\r\n                                <form>\r\n                                    <div class=\"row\">\r\n                                        <div v-if=\"!hidden_fields.includes('region')\" class=\"col-lg-6 col-sm-6\">\r\n                                            <div class=\"form-group\">\r\n                                                <label>{{helper.t(\"Region\")}}</label>\r\n                                                <vue_select \r\n                                                    :options=\"all_regions\"\r\n                                                    :label=\"helper.t('name_en')\"\r\n                                                    v-model=\"search_filters.region\"\r\n                                                    :reduce=\"region => region\"\r\n                                                    :dir=\"frappe.lang_dir\"\r\n                                                    @input=\"search_filters.city = null;load_cities();filters_updated();\"\r\n                                                >\r\n                                                </vue_select>\r\n                                            </div>\r\n                                        </div>\r\n                                        <div v-if=\"!hidden_fields.includes('city')\" class=\"col-lg-6 col-sm-6\">\r\n                                            <div class=\"form-group\">\r\n                                                <label>{{helper.t(\"City\")}}</label>\r\n                                                <vue_select \r\n                                                    :options=\"cities\"\r\n                                                    :label=\"helper.t('name_en')\"\r\n                                                    v-model=\"search_filters.city\"\r\n                                                    :reduce=\"city => city\"\r\n                                                    :dir=\"frappe.lang_dir\"\r\n                                                    @input=\"load_districts();filters_updated();\"\r\n                                                >\r\n                                                </vue_select>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"add-listing\">\r\n                                        <label>{{ helper.t(\"Property Types\") }}</label>\r\n                                        <div class=\"features-content mt-2\">\r\n                                            <div class=\"row\">\r\n                                                <div v-for=\"(status,property_type) in search_filters.property_types\" v-if=\"check_enabled(property_type)\" class=\"col-lg-3 col-md-4\">\r\n                                                    <ul>\r\n                                                        <li role=\"button\" @click=\"search_filters.property_types[property_type] = !search_filters.property_types[property_type]; filters_updated();\">\r\n                                                            <i v-if=\"status\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                                            {{helper.t(property_type+\"s\")}}\r\n                                                        </li>\r\n                                                    </ul>\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </form>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <!-- End Filter Area -->\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n    import * as global from \"../../js/global.js\" ;\r\n\timport * as helper from \"../../js/helper.js\";\r\n\timport full_loading from \"../components/full-loading.vue\";\r\n    import VueSelect from '../../js/vue-select.js';\r\n    import vueSlider from '../../js/vue-slider-component.umd.min.js';\r\n    \r\n\texport default{\r\n        components: {\r\n            full_loading:full_loading,\r\n            vue_select:VueSelect,\r\n            vueSlider: vueSlider\r\n        },\r\n\t\tname:'map_search_widget',\r\n        props: {\r\n            hidden_fields: {\r\n                default: function () {\r\n                    return [];\r\n                }\r\n            },\r\n            for_guest: {\r\n                type: Boolean,\r\n                default: false\r\n            },\r\n            search_filters_prop: {\r\n                default: function () {\r\n                    return global.search_projects_filters;\r\n                }\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                ageRange: [2, 5],\r\n                global,\r\n                helper,\r\n                frappe,\r\n                search_filters:this.search_filters_prop,\r\n                all_regions:[],\r\n                cities:[],\r\n                districts:[],\r\n                value: [0,40],\r\n                first_refresh:false,\r\n                formatter2: v => `${('' + v).replace(/\\B(?=(\\d{3})+(?!\\d))/g, ',')} ﷼`,\r\n                options: {\r\n                    dotSize: 14,\r\n                    width: 'auto',\r\n                    height: 4,\r\n                    contained: false,\r\n                    direction: 'ltr',\r\n                    data: null,\r\n                    dataLabel: 'label',\r\n                    dataValue: 'value',\r\n                    interval: 1,\r\n                    disabled: false,\r\n                    clickable: true,\r\n                    duration: 0.5,\r\n                    adsorb: true,\r\n                    lazy: true,\r\n                    tooltip: 'active',\r\n                    tooltipPlacement: 'top',\r\n                    tooltipFormatter: void 0,\r\n                    useKeyboard: false,\r\n                    keydownHook: null,\r\n                    dragOnClick: true,\r\n                    enableCross: true,\r\n                    fixed: false,\r\n                    minRange: void 0,\r\n                    maxRange: void 0,\r\n                    order: true,\r\n                    marks: false,\r\n                    dotOptions: void 0,\r\n                    dotAttrs: void 0,\r\n                    process: true,\r\n                    dotStyle: void 0,\r\n                    railStyle: void 0,\r\n                    processStyle: void 0,\r\n                    tooltipStyle: void 0,\r\n                    stepStyle: void 0,\r\n                    stepActiveStyle: void 0,\r\n                    labelStyle: void 0,\r\n                    labelActiveStyle: void 0,\r\n                }\r\n\t\t\t}\r\n\t\t},\r\n        mounted(){\r\n            global.emitter.on(\"refresh_filters\", args => {\r\n                this.first_refresh = true;\r\n                this.$forceUpdate();\r\n            });\r\n            global.emitter.on(\"update-filters\", args => {\r\n                this.filters_updated();\r\n            });\r\n            global.emitter.on(\"load_regions_n_cities\", args => {\r\n                this.load_regions();\r\n                this.load_cities();\r\n            });\r\n            this.load_regions();\r\n            this.load_cities();\r\n        },\r\n\t\tmethods: {\r\n\t\t\tload_regions: async function () {\r\n                this.all_regions = await global.global_params.get_regions(with_bounds = false);\r\n                this.$forceUpdate();\r\n\t\t\t},\r\n\t\t\tload_cities: async function () {\r\n                if(this.search_filters.region)\r\n                    this.cities = await global.global_params.get_cities(this.search_filters.region.region_id);\r\n                else\r\n                this.cities = await global.global_params.get_cities();\r\n                this.$forceUpdate();\r\n\t\t\t},\r\n\t\t\tload_districts: async function () {\r\n                return;\r\n                this.districts = await global.global_params.get_districts(this.search_filters.city.city_id);\r\n                this.$forceUpdate();\r\n\t\t\t},\r\n\t\t\tcheck_enabled: function(field){\r\n\t\t\t\tif (!this.search_filters.property_type)\r\n\t\t\t\t\treturn true;\r\n\t\t\t\treturn this.enabled_fields.includes(field);\r\n\t\t\t},\r\n            filters_updated: function (){\r\n                global.emitter.emit(\"load-search-again\");\r\n                global.emitter.emit(\"update-search-tablets\");\r\n            },\r\n            array_to_vue_select_obj: function(array){\r\n                return array.map((value) => {\r\n                    return {label: helper.t(value), code: value}\r\n                })\r\n            }\r\n\t\t},\r\n\t\tcomputed:{\r\n            enabled_fields(){\r\n                var fields = global.property_constants.property_types[this.search_filters.property_type];\r\n                return fields;\r\n            },\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n    .modal-dialog{\r\n        min-width: 60% !important;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/search-mashro-filters-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__